import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import ReviewStatus from 'notebook/reviews/ReviewStatus';
import {StudyForOverview} from 'studies/typed/utils/TypedStudyTypes';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';
import * as logging from 'util/Logging';

export default function CustomStudyDesignOverview({study}: {study: StudyForOverview}): JSX.Element {
  if (!study.designEntry) {
    logging.warn('Expected CUSTOM study to have a design entry');
    return <p>No design available.</p>;
  }
  // TODO(BNCH-71266) remove when we fix ReviewSummary type, see https://github.com/benchling/aurelia/pull/86236#discussion_r1270179302
  const review =
    !isInaccessible(study.designEntry) && study.designEntry.review
      ? {
          ...study.designEntry.review,
          authors: study.designEntry.review.authors,
          auditors: study.designEntry.review.auditorsJson,
          reviewLifecycleVersion: study.designEntry.review.reviewLifecycleVersion || undefined,
        }
      : undefined;
  return (
    <table
      className={css(styles.designTable)}
      {...getTestProps({component: 'CustomStudyDesignOverview', element: 'root'})}
    >
      <thead>
        <tr>
          <th className={css(styles.designTableTh)}>Study design entry</th>
          <th className={css(styles.designTableTh)}>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <BenchChip
              id={isInaccessible(study.designEntry) ? study.designEntry.invalidId : study.designEntry.id}
              size={ChipSize.MINI}
            />
          </td>
          <td>
            {isInaccessible(study.designEntry) ? (
              <p>You do not have permission to view the review status of the design entry.</p>
            ) : (
              <ReviewStatus review={review} />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

const styles = StyleSheet.create({
  designTable: {
    width: '100%',
    tableLayout: 'fixed',
  },
  designTableTh: {
    paddingBottom: 5,
  },
});
